import http from '@/plugins/axios/axios';

export default class ArquivoFolhaService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha/folha-pag', requisicao, {responseType: 'blob'});
    } 
}